import React from 'react';
import AboutImage from '../img/about.png';
import Underline from '../img/underline.webp';

const About = () =>{
    return(   
        <section className="about" class="pt-10 px-6 py-10 max-[420px]:px-4" id="about">
            <div className='mb-10'>
                <h1 class="text-5xl text-center font-bold max-md:text-5xl max-md:text-center max-sm:text-4xl text-[#118C5F]">ABOUT US</h1>
                <div className='flex justify-center mt-5'>
                    <img src={Underline} alt="about"/>
                </div>
            </div>
            <div className="container" class="flex flex-row max-md:text-center">
                <div  class="w-1/2 max-lg:mt-10 max-[1100px]:mt-10 max-[1000px]:mt-10 max-[1000px]:w-0">
                    <img src={AboutImage} alt="about"/>
                </div>
                <div className="right" class="px-7 w-1/2 mt-10 max-[1000px]:pl-4 max-[1000px]:pr-4 max-[1000px]:text-center max-[1000px]:w-full max-[900px]:mt-6 max-[1200px]:mt-0 max-[500px]:mt-1">
                    <p class="text-lg mt-8 text-gray-800 text-justify leading-10 max-[900px]:mt-5 max-[900px]:px-2 max-sm:text-lg max-[500px]:mt-1 max-[640px]:leading-loose">
                    Afya is a dedicated non-profit organization committed to promoting and maintaining health standards throughout Kenya. 
                    Our mission is simple yet powerful: to share vital health information with individuals from all walks of life, 
                    empowering them to make informed decisions about their well-being. We believe that when people are equipped with accurate and up-to-date health information, 
                    they can take control of their own health and lead healthier lives.
                    </p>
                </div>
            </div>
      </section>

    )
}

export default About